import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "identificati", label: "Ti riconosci?" },
  { id: "servizi", label: "Servizi" },
  { id: "approccio", label: "Approccio" },
  { id: "risultati", label: "Risultati" },
  { id: "faq", label: "FAQ" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const onLight = scrolled;
  const textBase = onLight ? "text-navy" : "text-ivory";
  const textMuted = onLight ? "text-navy/75 hover:text-navy" : "text-ivory/75 hover:text-ivory";
  const goldAccent = onLight ? "text-gold" : "text-goldSoft";

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        onLight ? "bg-ivory/85 backdrop-blur-md border-b border-line" : "bg-transparent"
      }`}
    >
      <div className="container-editorial flex items-center justify-between py-5">
        <button
          data-testid="brand-logo"
          onClick={() => goTo("hero")}
          className="flex items-baseline gap-2 group"
        >
          <span className={`font-serif text-2xl md:text-[26px] font-medium leading-none ${textBase}`}>
            Manuel Faustini
          </span>
          <span className={`text-[10px] tracking-[0.3em] uppercase font-semibold ${goldAccent}`}>
            CFA
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => goTo(l.id)}
              className={`text-[12px] tracking-[0.22em] uppercase link-underline ${textMuted}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-cta-contatti"
          onClick={() => goTo("contatti")}
          className={`hidden lg:inline-flex items-center gap-2 px-6 py-3 text-[11px] font-medium tracking-[0.2em] uppercase transition-all duration-300 hover:-translate-y-0.5 ${
            onLight
              ? "bg-navy text-ivory hover:bg-navySoft"
              : "bg-ivory text-navy hover:bg-goldSoft"
          }`}
        >
          Prenota un colloquio
        </button>

        <button
          data-testid="nav-mobile-toggle"
          className={`lg:hidden ${textBase}`}
          onClick={() => setOpen((v) => !v)}
          aria-label="Apri menù"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-panel" className="lg:hidden border-t border-line bg-ivory">
          <div className="container-editorial flex flex-col py-6 gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-${l.id}`}
                onClick={() => goTo(l.id)}
                className="text-left text-sm tracking-[0.18em] uppercase text-navy/80"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-cta"
              onClick={() => goTo("contatti")}
              className="btn-primary justify-center"
            >
              Prenota un colloquio
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
